export const localFeatureIds = [
  //
  'export video',
  'viz-plan-2026',
  'smartlook-canvas',
  'onboarding-pro-schedule',
  'signup-tracking-page',
  'price-alert',
  'slazzer',
  'viz-demo-overlay',
  'viz-take-photo-button',
  'viz-manual-distort',
  'viz-magic-render-floorplan',
  'viz-magic-erase-hide-feedback',
  'image-to-vizi',
] as const

export const externalFeatureIds = [
  //
  'viz-plan-2026',
  'smartlook-canvas',
  'onboarding-pro-schedule',
  'signup-tracking-page',
  'price-alert',
  'slazzer',
  'viz-demo-overlay',
  'viz-take-photo-button',
  'viz-manual-distort',
  'viz-magic-render-floorplan',
  'viz-magic-erase-hide-feedback',
  'image-to-vizi',
] as const

export type LocalFeatureId = (typeof localFeatureIds)[number]
export type ExternalFeatureId = (typeof externalFeatureIds)[number]
export type FeatureId = LocalFeatureId | ExternalFeatureId

export function isLocalFeature(
  featureId: FeatureId,
): featureId is LocalFeatureId {
  return localFeatureIds.includes(featureId as LocalFeatureId)
}

export function isExternalFeature(
  featureId: FeatureId,
): featureId is ExternalFeatureId {
  return externalFeatureIds.includes(featureId as ExternalFeatureId)
}
